module.exports = __webpack_public_path__ + "e6eef7042a6c241203b5ab1c2e3a7595.png";